import { FigureDataDto, LoadFunctionWithData } from "aic";
import axios from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";

export type GraphType = "SCATTER" | "VBAR" | "LINE" | "VBOX";

export type IBeFigureReturn = IAxiosReturn<string>;

/**
 * Generate a figure image from graph input.
 *
 * @param backEndUrl - Base backend URL
 * @param params - Graph input parameters for the figure
 * @param controller - AbortController to cancel the request
 * @returns Base64 image data wrapped in IBeFigureReturn
 */
export const getFigure: LoadFunctionWithData<FigureDataDto, string> = async (
  backEndUrl: string,
  params: FigureDataDto,
  controller: AbortController,
): Promise<IBeFigureReturn> => {
  try {
    const url = `${backEndUrl}Figure/generate`;

    const response = await axios.post(url, params, {
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
      signal: controller.signal,
    });

    // Convert blob to base64 data URL
    const blob = new Blob([response.data], { type: "image/png" });
    const reader = new FileReader();

    return new Promise((resolve) => {
      reader.onload = () => {
        resolve({
          success: true,
          data: reader.result as string,
        });
      };
      reader.onerror = () => {
        resolve({
          success: false,
          errorText: "Failed to process image data",
        });
      };
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    return processAxiosError("Generate BE figure failed", error);
  }
};
